import React, { useCallback, useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardBody } from "reactstrap";
import classnames from "classnames";
import { CLASSIFICATION, TABS, TABS_BUTTONS } from "pages/operations/routineDetails/constants";
import GeneralInformationTab from "pages/operations/routineDetails/Tabs/GeneralInformationTab";
import TasksTab from "pages/operations/routineDetails/Tabs/TasksTab";
import AssetsTab from "pages/operations/routineDetails/Tabs/AssetsTab";
import DetailsModal from "pages/operations/routineDetails/DetailsModal";
import { useLocation } from "react-router";

const useStyles = makeStyles({
  root: {
    width: "100%",
    marginTop: 30,
    display: "flex",
  },
  container: {
    borderRadius: 30,
    width: "100%",
    padding: 30,
  },
  tabs: {
    display: "flex",
    padding: "30px 0",
    fontSize: 13,
    fontWeight: 600,
    flexDirection: "column",
    marginRight: -4,
  },
  tab: {
    backgroundColor: "#E1E1E1",
    padding: 15,
    borderRadius: "10px 0 0 10px",
    marginBottom: 10,
    whiteSpace: "nowrap",

    "&:hover": {
      cursor: "pointer",
    },
  },
  active: {
    backgroundColor: "#FFFFFF!important",
  },
  cardBody: {
    padding: 0,
  },
});

const DataTabs = ({ routine, customers, updateDetails, isLoading }) => {
  const classes = useStyles();
  const searchParams = useLocation().search;
  const activeUrlTab = new URLSearchParams(searchParams).get("activeTab");
  const [activeTab, setActiveTab] = useState(activeUrlTab ?? TABS.GENERAL_INFORMATION);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const onTabClick = useCallback(e => {
    const tab = e.target.dataset.tab;
    setActiveTab(tab);
  }, []);

  const openDetailsModal = useCallback(customer => setSelectedCustomer(customer), []);
  const closeDetailsModal = useCallback(() => setSelectedCustomer(undefined), []);

  const hideViewBtn = useMemo(() => routine.status === "Close" || routine.status === "Suspended", [routine]);

  return (
    <div className={classes.root}>
      <div className={classes.tabs}>
        {TABS_BUTTONS.map(item => {
          if (item?.hideRoles?.includes(routine.assigneeRole)) return null;
          return (
            (routine.status !== "Close" || item.key === TABS.GENERAL_INFORMATION) && (
              <div
                key={item.key}
                className={classnames(classes.tab, activeTab === item.key && classes.active)}
                data-tab={item.key}
                onClick={onTabClick}
              >
                {item.title}
              </div>
            )
          );
        })}
      </div>
      <Card className={classes.container}>
        <CardBody className={classes.cardBody}>
          {activeTab === TABS.GENERAL_INFORMATION && <GeneralInformationTab routine={routine} />}
          {activeTab === TABS.PRIORITY_TASKS && (
            <TasksTab
              customers={customers[CLASSIFICATION.PRIORITY]}
              showAction={!hideViewBtn}
              onOpen={openDetailsModal}
              isLoading={isLoading}
            />
          )}
          {activeTab === TABS.REPOSSESSIONS_TASKS && (
            <TasksTab
              customers={customers[CLASSIFICATION.REPOSSESSIONS]}
              showAction={!hideViewBtn}
              onOpen={openDetailsModal}
              isLoading={isLoading}
            />
          )}
          {activeTab === TABS.INSTALLATIONS_TASKS && (
            <TasksTab
              customers={customers[CLASSIFICATION.INSTALLATIONS]}
              showAction={!hideViewBtn}
              onOpen={openDetailsModal}
              isLoading={isLoading}
            />
          )}
          {activeTab === TABS.FUTURE_TASKS && (
            <TasksTab
              customers={customers[CLASSIFICATION.FUTURE_TASKS]}
              showAction={!hideViewBtn}
              onOpen={openDetailsModal}
              isLoading={isLoading}
            />
          )}
          {activeTab === TABS.BACKLOG_TASKS && (
            <TasksTab
              customers={customers[CLASSIFICATION.BACKLOG]}
              showAction={!hideViewBtn}
              onOpen={openDetailsModal}
              isLoading={isLoading}
            />
          )}
          {activeTab === TABS.NOT_REACHABLE_TASKS && (
            <TasksTab
              customers={customers[CLASSIFICATION.NOT_REACHABLE]}
              showAction={!hideViewBtn}
              onOpen={openDetailsModal}
              isLoading={isLoading}
            />
          )}
          {activeTab === TABS.ASSETS && (
            <AssetsTab routine={routine} updateDetails={updateDetails} isLoading={isLoading} />
          )}
        </CardBody>
        {!!selectedCustomer && (
          <DetailsModal
            isOpen={!!selectedCustomer}
            customer={selectedCustomer}
            onClose={closeDetailsModal}
            updateRoutine={updateDetails}
          />
        )}
      </Card>
    </div>
  );
};

export default DataTabs;
